import auditService from 'resources/audit/audit.service';
import commentService from 'resources/comment/comment.service';

import { AUDIT_STATUSES } from 'resources/audit/audit.constants';

export const actualizeAuditStatus = async (auditId) => {
  const auditCommentsToResolve = await commentService.getAuditCommentsToResolve(auditId);

  if (!auditCommentsToResolve || auditCommentsToResolve?.length === 0) {
    await auditService.updateAudit({
      id: auditId,
      status: AUDIT_STATUSES.COMPLETED_SUCCESS,
    });
  }
};
